import { branchUsersCache } from '../cache-impl/branch-users-cache';
import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';
import { getInternalId } from '../../../webmodule-common/other/webmodule-common';
import { html } from 'lit';
import { SupportInboxView } from '../support-inbox/views/support-inbox-view';
import { TabbedPageBase } from './helpers/page-base';
import { tlang } from '../../../webmodule-common/other/language/lang';
import { userDataStore } from '../common/current-user-data-store';

@customElement('app-support-inbox')
export class AppSupportInbox extends TabbedPageBase {
  @state()
  supportInboxView: SupportInboxView | null = null;
  internalId: string = getInternalId();

  private userCache = branchUsersCache();

  constructor() {
    super();
  }

  meta() {
    return {
      title: tlang`Support Tickets`,
      description: tlang`Support Tickets`
    };
  }

  private get elementId(): string {
    return `support-inbox-page-${this.internalId}`;
  }

  protected async franchiseeInformationFactory(): Promise<SupportInboxView> {
    return await constructAsync(new SupportInboxView());
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.supportInboxView);
    this.supportInboxView = null;
  }

  protected async afterUserConnected() {
    await userDataStore.reLoadFranchisee();
    this.supportInboxView = await this.franchiseeInformationFactory();
    await super.afterUserConnected();
  }

  protected async setActiveTabByHash(): Promise<void> {
    await this.supportInboxView?.setActiveTabByHash();
  }

  render() {
    if (!this.loggedIn) return html``;
    return html`
      <div id=${this.elementId} class="page-content">
        <div class="page-container">${this.supportInboxView?.ui}</div>
      </div>
    `;
  }

  protected async awaken(): Promise<void> {
    await this.userCache.prefetch([userDataStore.defaultBranch.id]);
  }
}
